import { reactive } from 'vue';

const state = reactive({ version: 0 });

export function useSubmissionsRefresh() {
  return {
    state,
    notify: () => {
      state.version += 1;
    },
  };
}
